export const OAUTH_STARTED_STORAGE_KEY = "wecom-oauth-started";
export const OAUTH_RETRY_WINDOW_MS = 60_000;

export function shouldStartOAuth(nowMs: number, storedTimestamp: string | null): boolean {
  if (!storedTimestamp) {
    return true;
  }

  const lastStartedAt = Number(storedTimestamp);
  if (!Number.isFinite(lastStartedAt)) {
    return true;
  }

  return nowMs - lastStartedAt >= OAUTH_RETRY_WINDOW_MS;
}

export function isOAuthStartThrottled(nowMs: number, storedTimestamp: string | null): boolean {
  return !shouldStartOAuth(nowMs, storedTimestamp);
}

export function readOAuthError(search: string): { oauthError: string; wecomErrcode: number | null } | null {
  const params = new URLSearchParams(search);
  const oauthError = params.get("oauth_error");
  if (!oauthError) {
    return null;
  }

  const errcode = params.get("wecom_errcode");
  return {
    oauthError,
    wecomErrcode: errcode ? Number(errcode) : null
  };
}
